import { graphHooks } from '@tunasong/graph-lib/react'
import { useRecentSplit } from '@tunasong/search'
import { useFavorites } from '@tunasong/ui-lib'
import { mergeContinueItems } from './continue-items.js'

/**
 * What Home's Continue shelf shows: pinned entities (in pin order), then the entities I last edited
 * (`useRecentSplit().mine`), deduped and capped. `isEmpty` is the first-run state, settled only once loaded.
 */
export const useContinueItems = () => {
  const { mine, isLoading: isLoadingSplit } = useRecentSplit()
  const { pinnedFavorites } = useFavorites()

  const pinnedIds = pinnedFavorites.map(f => f.entityId).filter((id): id is string => typeof id === 'string')
  const mineIds = mine.map(e => e.id)
  const { existingEntities = [], isLoading: isResolving } = graphHooks.useEntitiesById([
    ...new Set([...pinnedIds, ...mineIds]),
  ])
  const items = mergeContinueItems({
    pinnedIds,
    mineIds,
    entitiesById: new Map(existingEntities.map(e => [e.id, e])),
  })

  const loading = isLoadingSplit || isResolving
  return { items, loading, isEmpty: !loading && items.length === 0 }
}
